exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-loader[data-v-e22a5fcc]{margin-top:2.5rem}", ""]);

// exports
